import { directiveSettings } from '../../utils/parse';
/**
 * @module directives/action/tracker
 */

/**
 * Track event buy sending to SEO services.
 * @param {String} [category='lead'] - The event category.
 * @param {String} [action='click'] - The event type.
 * @param {String} [label=''] - The event label.
 * @param {Number} [timeout=1000] - The fail timeout.
 * @returns {Promise}
 */
function trackEvent(category = 'lead', action = 'click', label = '', timeout = 1000) {
	const promises = [];

	// Google Analytics
	if (typeof ga === 'function') {

		promises.push(new Promise((resolve, reject) => {
			ga('send', {
				hitType: 'event',
				eventCategory: category,
				eventAction: action,
				eventLabel: label,
				hitCallback: _ => resolve(),
			});
			setTimeout(_ => reject(), timeout);
		}));
	}

	// Facebook Pixel
	if (typeof fqb === 'function') {
		promises.push(new Promise((resolve, reject) => {
			fbq('track', 'Lead');
			resolve();
		}));
	}

	return Promise.all(promises);
}

/**
 * Apply tracker controls.
 */
export default function trackerDirective() {
  document.querySelectorAll('[data-sw-tracker]').forEach(element => {    
		const data = element.getAttribute('data-sw-tracker'),
    settings = directiveSettings(data, {
      on: 'auto',
      type: 'lead',
      label: '',
      timeout: 1000,
    }, 'label');

		if (settings.on === 'auto') settings.on = element.matches('form') ? 'submit' : 'click';

    const tracker = event => {

      event.preventDefault();
      event.stopImmediatePropagation();

      const trigger = _ => {
        element.removeEventListener(settings.on, tracker);

        if (settings.on === 'click' && element.matches('a[href]')) { 
          element.dispatchEvent(new MouseEvent('click'));
        } else {
          if (settings.on === 'submit') {
            element.dispatchEvent(new SubmitEvent("submit", { submitter: event.target }));
          } else if (settings.on === 'click') {
            element.dispatchEvent(new MouseEvent('click'));
          }
        }
      };
			trackEvent(settings.type, settings.on, settings.label, settings.timeout).then(trigger).catch(trigger);
		};

    element.addEventListener(settings.on, tracker);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/tracker.js